var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { Portal } from "../_Portal";
// subcomponents
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ModalContent from "./ModalContent";
// styles
import variables from "../../theme/variables.module.scss";
import "./modal.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-modal",
    className: undefined,
    verticalPosition: "center",
    style: undefined,
};
/**
 * A modal is an interface element that appears over other content. It requires an interaction from the user before they can return to whatever is underneath.
 */
const Modal = (_a) => {
    var { className, children, isOpen, onClose, closeOnBackDropClick, verticalPosition, size, width, style, disabledMobileAnimation } = _a, rest = __rest(_a, ["className", "children", "isOpen", "onClose", "closeOnBackDropClick", "verticalPosition", "size", "width", "style", "disabledMobileAnimation"]);
    const classList = classNames("tecma-modal", className, {
        [`${size}`]: size,
    });
    const containerClassList = classNames("tecma-modal-container", {
        [`${verticalPosition}`]: verticalPosition,
        isOpen,
        "disable-mobile-animation": disabledMobileAnimation,
    });
    const widthStyle = width && { width: `${width}rem` };
    const modalBackDrop = useRef(null);
    const onBackDropClick = (e) => {
        if (!closeOnBackDropClick) {
            return;
        }
        if (e.target === modalBackDrop.current) {
            onClose();
        }
    };
    const [shouldRender, setRender] = useState(isOpen);
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
            setRender(true);
        }
        if (!isOpen) {
            document.body.style.overflow = "unset";
            if (window.innerWidth > Number.parseInt(variables.tablet, 10)) {
                setRender(false);
            }
        }
    }, [isOpen]);
    const onAnimationEnd = () => {
        if (!isOpen)
            setRender(false);
    };
    return (_jsx(Portal, { id: "tecma-floatingModal", children: shouldRender && (_jsx("div", Object.assign({ className: containerClassList }, rest, { "aria-hidden": "true", onClick: onBackDropClick, ref: modalBackDrop, children: _jsx("div", { style: Object.assign(Object.assign({}, style), widthStyle), className: classList, onAnimationEnd: onAnimationEnd, children: children }) }))) }));
};
Modal.defaultProps = defaultProps;
const ModalSpace = Object.assign(Modal, {
    Header: ModalHeader,
    Footer: ModalFooter,
    Content: ModalContent,
});
export { ModalSpace as Modal };
